import { getAccessToken } from '@neotech-solutions-org/neofusion-fe-shared';
import { InternalAxiosRequestConfig } from 'axios';
import { DEFAULT_LANGUAGE, SELECTED_LANGUAGE_STORAGE_KEY } from '../localization/utils';
import { ApiService, casinoAccessToken } from './api';
import i18next from 'i18next';

type HeaderProvider = (config: InternalAxiosRequestConfig) => Promise<Record<string, string>>;

export const createAuthHeader = async (config: InternalAxiosRequestConfig): Promise<Record<string, string>> => {
  const token = await getAccessToken();

  if (!token) return {};

  return { Authorization: `Bearer ${token}` };
};

export const createCasinoAuthHeader = async (): Promise<Record<string, string>> => {
  if (!casinoAccessToken) return {};

  return { Authorization: `Bearer ${casinoAccessToken}` };
};

const getStoredLanguage = () => {
  try {
    if (typeof window === 'undefined') return null;

    const storedValue = window.localStorage.getItem(SELECTED_LANGUAGE_STORAGE_KEY);
    return storedValue ? JSON.parse(storedValue) : null;
  } catch (error) {
    /* eslint-disable no-console */
    console.warn('Failed to get language from localStorage:', error);
    return null;
  }
};

export const createLanguageHeader = async () => {
  const storedLanguage = getStoredLanguage();
  const lang = storedLanguage ?? i18next.language ?? DEFAULT_LANGUAGE;

  return { lang };
};

export const getServiceHeaders: { [key in ApiService]?: HeaderProvider[] } = {
  feed: [createAuthHeader, createLanguageHeader],
  wallet: [createAuthHeader],
  crm: [createAuthHeader],
  casino: [createCasinoAuthHeader, createLanguageHeader],
};
